export enum AppRoutes {
  HOME = '/',
  APPLICATIONS = 'applications',
  RENEWAL = 'renewal',
  OTHER = '**',
}

export enum APIRoutes {
  API = 'api',
}

export enum SourceRoutes {
  I18N = 'i18n',
  IMAGES = 'images',
  CONTENT = 'content',
  FILES = 'files',
}
